import honestInTheDarkCover from "@/assets/books/honest-in-the-dark.png";
import sheepBiteCover from "@/assets/books/sheep-bite.png";
import builtOnPurposeCover from "@/assets/books/built-on-purpose.png";
import cheatCodeCover from "@/assets/books/the-cheat-code-for-men.png";
import aboutMenCover from "@/assets/books/about-men-magazine.png";
import bibleMadeSimpleCover from "@/assets/books/entire-bible-made-simple.png";
import makingCentsCover from "@/assets/books/making-cents-of-it-all.png";
import kindlePublishingCover from "@/assets/books/kindle-publishing.png";
import cheatCodeMindDumpCover from "@/assets/books/cheat-code-mind-dump.png";
import spinCycleCover from "@/assets/books/the-spin-cycle.png";
import aiNotEnemyCover from "@/assets/books/ai-is-not-your-enemy.png";

// Editable content for DrSullySpeaks. Swap copy here without touching layouts.

export const PHONE_DISPLAY = "(855) 76-COACH";
export const PHONE_HREF = "tel:+18557626224";
export const EMAIL = "DrSully@DrSullySpeaks.com";

export const SOCIALS = [
  { label: "Instagram", handle: "@DrSullySpeaks", href: "https://instagram.com/DrSullySpeaks" },
  { label: "TikTok", handle: "@DrSullySpeaks", href: "https://tiktok.com/@DrSullySpeaks" },
  { label: "X / Twitter", handle: "@DrSullySpeaks", href: "https://x.com/DrSullySpeaks" },
  { label: "YouTube", handle: "@DrSullySpeaks", href: "https://youtube.com/@DrSullySpeaks" },
  { label: "LinkedIn", handle: "@drsullyspeaks", href: "https://www.linkedin.com/in/drsullyspeaks/" },
  { label: "Facebook (Business)", handle: "DrSullySpeak", href: "https://facebook.com/DrSullySpeak" },
  { label: "Facebook (Personal)", handle: "@DrSullySpeaksTruth", href: "https://facebook.com/DrSullySpeaksTruth" },
  { label: "Substack", handle: "@DrSullySpeaks", href: "https://substack.com/@drsullyspeaks" },
  { label: "Stan Store", handle: "@DrSullySpeaks", href: "https://stan.store/DrSullySpeaks" },
  // saysostore.myshopify.com 301s to sayso.store, which no longer resolves
  // (NXDOMAIN) — caught by scripts/link-check.ts. Point at the live storefront.
  { label: "Shopify Store", handle: "Say So Society", href: "https://saysosociety.com/collections/drsullyspeaks-merch" },
  { label: "Podcast", handle: "Honest Kingdom Voice", href: "https://open.spotify.com/show/6t5G1oDtkligs6wi4iGgvZ" },
  { label: "Make Change Now", handle: "makechangenow.pro", href: "https://makechangenow.pro" },
];

// Credentials shown publicly. Only credentials that have been individually
// named and classified (earned vs honorary) belong here. Do NOT add
// "three doctoral degrees" language until each degree is verified.
export const CREDENTIALS = [
  "PsyD — Industrial/Organizational Psychology",
  "ThD — Doctor of Theology",
  "DMin — Doctor of Ministry",
  "CERC — Certified Equity & Resiliency Coach",
];

export const TICKER = [
  "Industrial/Organizational Psychology",
  "Executive & Organizational Consulting",
  "Trauma-Informed Leadership Coach",
  "Certified Equity & Resiliency Coach",
  "AI Consultant",
  "Educator · Pastor · Author · Speaker",
  "PsyD · ThD · DMin · CERC",

  "20+ Years of Impact",
];

// Homepage proof points. Keep to four maximum. Every number must be defensible;
// unverified figures are removed rather than rounded. Rendered as raw strings —
// the animated CountUp component seeds its state with the final value so the
// correct number is visible even if animation never runs.
export const STATS = [
  { value: "20+", label: "Years of Impact" },
  { value: "375+", label: "Clients Served" },
  { value: "100+", label: "Organizations Served" },
  { value: "CERC", label: "Certified Equity & Resiliency Coach" },
];


export const AUDIENCES = [
  {
    title: "Executives & Founders",
    desc: "C-suite leaders who need clarity, accountability, and a strategy that survives scrutiny.",
  },
  {
    title: "Organizations & Teams",
    desc: "Boards, ministries, and institutions ready to reset culture, leadership, and systems.",
  },
  {
    title: "Pastors & Faith Leaders",
    desc: "Shepherds who want boardroom-ready strategy without losing prophetic edge.",
  },
  {
    title: "Coaches & Consultants",
    desc: "Practitioners who want to package their expertise into a fundable, scalable offer.",
  },
];

// Three primary service cards on the homepage — spec-verbatim copy.
// Do not expand this to one card per sub-service; sub-services live on the
// Consulting page (Phase 2). TODO(verify): claim wording pending final legal
// review of regulated titles ("clinical", "licensed", etc.) — none present.
export const SERVICES = [
  {
    id: "speaking",
    eyebrow: "Speaking and Training",
    title: "Speaking and Training",
    desc: "Keynotes, workshops, leadership development, ministry training, trauma-informed leadership, emotional intelligence, equity and resiliency, conflict resolution, organizational change, and AI readiness.",
    bullets: [
      "Keynotes for corporate, faith, civic, and academic audiences",
      "Workshops and leadership development",
      "Trauma-informed leadership training",
      "AI readiness for leaders",
    ],
    cta: "Invite Dr. Sully to Speak",
  },
  {
    id: "consulting",
    eyebrow: "Executive and Organizational Consulting",
    title: "Executive and Organizational Consulting",
    desc: "Executive coaching, organizational assessment, culture repair, team alignment, conflict intervention, strategic planning, leadership retreats, systems development, AI consulting, and implementation support.",
    bullets: [
      "Executive coaching and leadership assessment",
      "Culture and systems repair",
      "Conflict resolution and team alignment",
      "AI strategy and implementation support",
    ],
    cta: "Explore Consulting",
  },
  {
    id: "certification",
    eyebrow: "Certification and Leadership Development",
    title: "Certification and Leadership Development",
    desc: "CERC certification, leadership cohorts, facilitator development, ministry leadership training, trauma-informed education, MakeChange curriculum, continuing education, and future licensing opportunities.",
    bullets: [
      "CERC certification pathway",
      "Leadership cohorts and facilitator development",
      "MakeChange curriculum and continuing education",
      "Institutional licensing opportunities",
    ],
    cta: "Explore Certification",
  },
];

// Problem areas rendered on the homepage "When People Problems Become
// System Problems" grid. Kept as a flat string list so ordering + count
// stays easy to tweak without touching layout.
export const PROBLEMS = [
  "Leadership fatigue",
  "Conflict and communication breakdowns",
  "Low trust",
  "Unclear roles and accountability",
  "Trauma affecting leadership or culture",
  "Organizational resistance",
  "Team misalignment",
  "Mission drift",
  "AI confusion and poor implementation",
  "Leadership succession",
  "Burnout",
  "Inconsistent execution",
];

// The public MakeChange Operating System — Dr. Sully's signature IP.
// Public framing: Make Sense / Make Systems / Make Change.
// Internal implementation shorthand: Diagnose · Design · Deploy.
export const MAKECHANGE_OS = [
  {
    stage: "Make Sense",
    desc: "Identify the real issue. Separate symptoms from root causes. Assess people, leadership, culture, communication, and systems.",
    op: "Diagnose",
  },
  {
    stage: "Make Systems",
    desc: "Create clear structures, workflows, decision rights, communication practices, leadership standards, and accountability.",
    op: "Design",
  },
  {
    stage: "Make Change",
    desc: "Implement the plan, coach the leaders, measure progress, correct breakdowns, and sustain the transformation.",
    op: "Deploy",
  },
];

export const PROOF = [
  {
    quote:
      "Dr. Sully doesn't just coach — he recalibrates your entire operating system. The clarity I gained in one session was worth more than years of conventional coaching.",
    role: "CEO, San Antonio",
  },
  {
    quote:
      "He sees what you can't see about yourself. The most honest voice I've encountered in leadership development — and that honesty is exactly what produces results.",
    role: "Director, Title I Education",
  },
  {
    quote:
      "The 490X framework changed how I run my business and my household. Forgiveness as a strategy? I didn't believe it until I lived it.",
    role: "Entrepreneur, Texas",
  },
];

export const ECOSYSTEM = [
  { name: "DrSullySpeaks", desc: "The Honest Kingdom Voice" },
  { name: "Organic Coaching & Consulting", desc: "He Speaks Organic Coaching & Consulting LLC" },
  { name: "Anchored SA", desc: "The San Antonio Community Church" },
  { name: "490X", desc: "A Movement to Forgiveness" },
  { name: "Brand YOUniversity", desc: "Locating YOU again" },
  { name: "The Forge SA", desc: "Mentorship for men and boys" },
];

export const BOOKS: ReadonlyArray<{
  format: string;
  title: string;
  subtitle: string;
  desc: string;
  image: string;
  alt: string;
  featured?: boolean;
  buyLinks?: ReadonlyArray<{ label: string; href: string }>;
}> = [
  {
    format: "New Release",
    title: "AI Is Not Your Enemy",
    subtitle: "A faith-informed guide to leading with AI without losing your soul",
    desc: "Dr. Sully's newest release — a clear, faith-anchored framework for leaders, pastors, and founders who want to use AI with wisdom, discernment, and Kingdom purpose. Available now in ebook and paperback.",
    image: aiNotEnemyCover,
    alt: "Cover of AI Is Not Your Enemy by Dr. RD Sully Sullivan featuring a glowing cross above a circuit-board horizon.",
    featured: true,
    buyLinks: [
      {
        label: "Buy Ebook",
        href: "https://www.lulu.com/shop/dr-rd-sully-sullivan-and-drsullyspeaks-and-make-change-ai/ai-is-not-your-enemy/ebook/product-zmn4p44.html",
      },
      {
        label: "Buy Paperback",
        href: "https://www.lulu.com/shop/dr-rd-sully-sullivan-and-make-change-ai-and-drsullyspeaks/ai-is-not-your-enemy/paperback/product-2mnj6jw.html",
      },
    ],
  },
  {
    format: "Book",
    title: "Honest in the Dark",
    subtitle: "Fighting for joy without faking it",
    desc: "A faith-centered book for readers who need language for grief, honesty, and joy that does not depend on pretending everything is fine.",
    image: honestInTheDarkCover,
    alt: "Cover of Honest in the Dark by R.D. Sullivan featuring a lit candle in darkness.",
  },
  {
    format: "Book",
    title: "Sheep Bite",
    subtitle: "A Synopsis of True Church Leadership",
    desc: "A direct examination of church leadership, shepherding, and the spiritual responsibility of caring for people without performance or abuse.",
    image: sheepBiteCover,
    alt: "Cover of Sheep Bite with large title text, shepherd imagery, and a ram portrait.",
  },
  {
    format: "Book",
    title: "Built on Purpose",
    subtitle: "A framework for leaders who refuse to lead from broken places",
    desc: "A leadership framework focused on healing, purpose, and disciplined execution for leaders who want depth before visibility.",
    image: builtOnPurposeCover,
    alt: "Cover of Built on Purpose featuring Dr. Sully in an orange jacket against a cracked stone background.",
  },
  {
    format: "Journal",
    title: "The Cheat Code for Men",
    subtitle: "A Toolkit for Men's Prayer",
    desc: "A guided prayer + mind-dump toolkit built to help men process pressure, thought patterns, frustration, and discipline in a more honest way. Available in ebook and paperback.",
    image: cheatCodeCover,
    alt: "Cover of The Cheat Code for Men journal with black-and-white imagery of two clenched fists.",
    buyLinks: [
      {
        label: "Buy Ebook",
        href: "https://www.lulu.com/shop/dr-rd-sully-sullivan-and-drsullyspeaks/the-cheat-code-for-men/ebook/product-v87pnjj.html",
      },
      {
        label: "Buy Paperback",
        href: "https://www.lulu.com/shop/dr-rd-sully-sullivan-and-drsullyspeaks-and-the-honest-kingdom-voice/the-cheat-code-for-men-a-toolkit-for-mens-prayer/paperback/product-yvrp9dw.html",
      },
    ],
  },

  {
    format: "Magazine",
    title: "About Men",
    subtitle: "MAKE CHANGE Mens Magazine",
    desc: "A lifestyle and culture magazine exploring masculinity, fashion, mental strain, identity, and how men navigate the world they are expected to carry.",
    image: aboutMenCover,
    alt: "Cover of About Men magazine featuring Dr. Sully wearing sunglasses and a brown suit.",
  },
  {
    format: "Study Resource",
    title: "The Entire Bible Made Simple",
    subtitle: "For sinners",
    desc: "A visual teaching resource designed to make Scripture easier to follow for beginners, skeptics, and learners who need the big picture first.",
    image: bibleMadeSimpleCover,
    alt: "Cover of The Entire Bible Made Simple for Sinners with illustrated Bible overview sheets.",
  },
  {
    format: "Devotional",
    title: "Making Cents of It All",
    subtitle: "A 120-day devotional for underpaid educators",
    desc: "A 120-day devotional written for teachers, paraprofessionals, and school staff navigating financial strain while still showing up for kids every day.",
    image: makingCentsCover,
    alt: "Cover of Making Cents of It All devotional featuring a mason jar of coins with a growing plant.",
  },
  {
    format: "Guide",
    title: "Step-by-Step Introduction to Kindle Publishing",
    subtitle: "No bull — just the process",
    desc: "A straightforward walkthrough of self-publishing on Kindle for first-time authors who want the steps without the fluff or upsells.",
    image: kindlePublishingCover,
    alt: "Cover of Step-by-Step Introduction to Kindle Publishing with a no-bull icon and Kindle device.",
  },
  {
    format: "Journal",
    title: "The Cheat Code for Men — Mind Dump Journal",
    subtitle: "Journaling is for men too",
    desc: "A mind-dump journal built for men who need a place to offload pressure, process thought patterns, and reset before reacting.",
    image: cheatCodeMindDumpCover,
    alt: "Cover of The Cheat Code for Men Mind Dump Journal featuring a hooded figure and a small house at night.",
  },
  {
    format: "Devotional",
    title: "The Spin Cycle",
    subtitle: "A 7-day devotional",
    desc: "A short, focused 7-day devotional for seasons when life feels like it is spinning — designed to interrupt the loop and reset perspective.",
    image: spinCycleCover,
    alt: "Cover of The Spin Cycle 7-day devotional featuring a stylized washing machine drum with swirling water.",
  },
];

export const SCAN_LANES = [
  { value: "school_youth", label: "School & Youth Development" },
  { value: "leadership_culture", label: "Leadership & Workplace Culture" },
  { value: "faith_community", label: "Faith & Community Transformation" },
  { value: "trauma_resilience", label: "Trauma Healing & Resilience" },
  { value: "ai_readiness", label: "AI Skills & Digital Readiness" },
];

export const SCAN_RESULTS: Record<
  string,
  { headline: string; pathway: string; bullets: string[] }
> = {
  school_youth: {
    headline: "Build a fundable youth development program",
    pathway:
      "Your expertise can become a structured, fundable program for districts, after-school networks, and youth-serving nonprofits.",
    bullets: [
      "Equity-centered curriculum design",
      "Trauma-informed staff training",
      "Outcome reporting that satisfies funders",
    ],
  },
  leadership_culture: {
    headline: "Engineer a culture reset leaders will fund",
    pathway:
      "Translate your leadership work into an executive-ready culture and equity engagement model.",
    bullets: [
      "Leadership audit + alignment workshop",
      "Manager enablement system",
      "Quarterly operating rhythm and metrics",
    ],
  },
  faith_community: {
    headline: "Turn ministry insight into a transformation framework",
    pathway:
      "Package what you do in community into a faith-safe, boardroom-credible program churches and coalitions can adopt.",
    bullets: [
      "Frameworks like 490X — A Movement to Forgiveness",
      "Pastoral leadership cohorts",
      "Community partnership and grant alignment",
    ],
  },
  trauma_resilience: {
    headline: "Productize your healing work without diluting it",
    pathway:
      "Build a trauma-informed offering that serves clients with rigor and protects the people doing the work.",
    bullets: [
      "Clinical-adjacent program structure",
      "Practitioner training pathway",
      "Outcome and safety protocols",
    ],
  },
  ai_readiness: {
    headline: "Become the human-first AI partner your sector trusts",
    pathway:
      "Position your team as the trusted, faith-safe AI implementer — not a vendor selling tools.",
    bullets: [
      "AI readiness diagnostic for your org type",
      "Human-first deployment playbooks",
      "Governance, risk, and ethics scaffolding",
    ],
  },
};

export const INQUIRY_LANES = [
  {
    value: "speaking",
    label: "Keynote Speaking",
    desc: "Conferences, corporate events, universities, faith gatherings.",
  },
  {
    value: "coaching",
    label: "Executive Coaching",
    desc: "1:1 coaching for executives, founders, and leaders.",
  },
  {
    value: "consulting",
    label: "Organizational Consulting",
    desc: "Culture reset, leadership pipelines, operational redesign.",
  },
];
